import Radio from "../../../utils/components/Radio";

const RadioLayout = ({ items, name, onChange, isVertical, disabled }) => {
  return (
    <div
      className={`d-flex w-100 ${
        isVertical ? `flex-column align-items-start` : `justify-content-between`
      }`}
    >
      {items.map((item, index) => (
        <Radio
          key={index}
          label={item.label}
          name={name}
          checked={item.checked}
          onChecked={() => onChange(item.label)}
          disabled={disabled}
        />
      ))}
    </div>
  );
};
export default RadioLayout;
